import { makeStyles } from '@mui/styles';
import { transfer } from 'features/Delegation/services/CreditTransferServices';

export const useStyles = makeStyles((theme) => ({
  '@global': {
    '@keyframes shine': {
      from: {
        right: '-75%',
      },
      to: {
        right: '125%',
      },
    },
  },
  root: {
    color: '#FFFFFF',
  },

  arrowRight: {
    position: 'absolute',
    right: '7px',
    top: '30px',
    cursor: 'pointer',
    '&.showArrow': {
      opacity: '0.5',
      transitionDuration: '700ms',
      '&:hover': {
        opacity: '1',
        transitionDuration: '700ms',
      },
    },
  },
  subjectTabs: {
    position: 'absolute',
    bottom: '74px',
    left: '45px',
    opacity: '0.1',
    '@media(max-width: 550px)': {
      bottom: '74px',
      left: '45px',
    },
    '& svg': {
      opacity: '0.3',
      '@media(max-width: 550px)': {
        width: '150px!important',
        height: '150px!important',
      },
    },
  },

  sidebar: {
    width: '132px',
    height: '100%',
    float: 'right',
    position: 'relative',
    transitionDuration: '700ms',
    '@media(max-width: 550px)': {
      width: '100%!important',
    },
    '&.showContent': {
      width: '370px',
      transitionDuration: '700ms',
      '@media(max-width: 550px)': {
        width: '100%!important',
      },
    },
  },
  child: {
    '& .MuiListItemText-primary': {
      color: '#fff',
      fontSize: '11.5px',
      paddingLeft: '30px',
      height: '40px',
      lineHeight: '40px !important',
    },
  },
  listItemTextNested: {
    '& .MuiListItemText-primary': {
      color: '#fff',
      fontSize: '12px',
      paddingLeft: '21px',
      height: '44px',
      lineHeight: '44px !important',
      transitionDuration: '700ms',
      width: '94%',
      margin: 'auto',
      borderRadius: '5px',
      '&:hover': {
        background: '#FFFFFF1F',
        transitionDuration: '700ms',
        display: 'block',
        color: '#fff',

      },
    },
    '&.activeLink': {
      paddingLeft: '0!important',
      transitionDuration: '700ms',
      background: '#FFFFFF1F',
      transitionDuration: '700ms',
      color: '#fff',
      display: 'block',
      borderRadius: '5px',
      width: '93%',
      margin: 'auto',
      '&:hover': {
        '& .MuiListItemText-primary': {
          background: 'inherit',
        },
      },

      '& .MuiListItemText-primary': {
        paddingLeft: '13px!important',
      },
    },
  },
  listItemText: {
    color: '#fff',
    fontSize: '12.5px',
    paddingLeft: '30px',
    transitionDuration: '700ms',
    height: '44px',
    lineHeight: '44px !important',
    display: 'block',
    width: '100%',
    height: '100%',
  },
  arrow: {
    color: theme.palette.icon,
    width: 15,
    height: 15,
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    left: '6px',
    transitionDuration: '700ms',
    top: '13px',
    '& svg': {
      transform:'scale(1.3) translate(1px, 0)',
    },
  },
  listItemTextItems: {
    '& .MuiTypography': {
      '&-body1': {
        color: '#fff',
        fontSize: '12.5px',
        paddingLeft: '30px',
        lineHeight: '44px',
        height: '44px',
      },
    },
    '&.expand': {
      '& .MuiTypography': {
        '&-body1': {
          color: '#9FA5CB',
        },
      },
    },
  },
  hideCollapse: {
    height: '0',
    transition: ' opacity 0.5s ease-in-out',
    transitionProperty: 'height, opacity',

    opacity: '0',
  },
  showCollapse: {
    height: 'auto',
    transition: ' opacity 0.5s ease-in-out',
    transitionProperty: 'height, opacity',
    opacity: '1',
  },
  blockList: {
    position: 'relative',
    transitionDuration: '700ms',
    marginBottom: '10px',
    overflow: 'hidden',

    '&:hover': {
      background: '#3f4faa52',
      transitionDuration: '700ms',
      cursor: 'pointer',
    },
    '& .activeLink': {
      background: '#FFFFFF1F',
      transitionDuration: '700ms',
      color: '#fff',
      display: 'block',
      borderRadius: '5px',
      width: '93%',
      margin: 'auto',
      paddingLeft: '21.5px',
    },
    '& .MuiListItemText-root': {
      marginTop: '0',
    },
    '&.activeItem': {
      borderBottom: '1px solid #FFFFFF3D',
      transitionDuration: '700ms',
      '&:last-child': {
        borderBottom: '0',
      },
      '& .MuiCollapse-entered': {
        transitionDuration: '700ms',
        position: 'relative',
      },
      '& .MuiCollapse-wrapperInner': {
        height: '100%',
        transitionDuration: '700ms',
      },
    },
  },

  collaps: {
    transition: 'all 0.25s ease-in-out',
    overflow: 'hidden',
    display: 'none',
  },
  collapsOpen: {
    position: 'relative',
    overflow: 'hidden',
    transitionDuration: '354ms',
    display: 'Block',
  },

  menuError: {
    width: 'auto',
    height: '40px',
    color: '#fff',
    fontSize: '12px',
    textAlign: 'center',
    padding: '0 18px',
    lineHeight: '22px',
    marginTop: '60px',
    '& a': {
      width: '80px',
      height: '27px',
      color: '#37459f',
      background: '#fff',
      padding: '10px',
      display: 'block',
      lineHeight: '7px',
      margin: '15px auto 0',
      borderRadius: '4px',
      cursor: 'pointer',
      fontWeight: '500',
    },
  },
  logoLight: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '14px  auto',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '500px',
    width: '60px',
    height: '60px',
    '&::before': {
      backgroundImage:
        'linear-gradient(to right, rgb(46 60 147 / 42%) 0%, #2d3a92 50%, rgb(45 59 146 / 20%) 100%)',
      display: 'block',
      content: `" "`,
      height: '100%',
      right: '-75%',
      position: 'absolute',
      animation: `shine 15s infinite ease`,
      top: '0',
      transform: 'skewX(-25deg)',
      width: '37%',
      zIndex: '2',
    },
  },
  version: {
    position: 'fixed',
    left: '0',
    bottom: '0',
    color: ' #FFFFFF52',
    fontSize: ' 10px',
    width: '130px',
    background: 'linear-gradient(90deg, #4050AC 0%, #2C3990 100%)',
    height: '40px',
    textAlign: 'center',
    lineHeight: '40px',
    cursor: 'pointer',
    transitionDuration: '700ms',
    '&:hover': {
      color: '#fff',
      transitionDuration: '700ms',
    },
  },
  sidebarBlock: {
    display: 'flex',
    height: '100%',
    position: 'fixed',
    left: '0',
    top: '65px',
  },

  sidebarTab: {
    width: '130px',
    background: 'linear-gradient(90deg, #4050AC 0%, #2C3990 100%)',
  },
  sidebarContent: {
    background: '#303D8F',
    transitionDuration: '700ms',
    width: '0',
    paddingTop: '90px',
    position: 'relative',
    overflow: 'hidden',

    '&.showContent': {
      width: '240px',
      transitionDuration: '700ms',
    },
  },
  tabContentDetail: {
    marginBottom: '30px',
    overflowY: 'auto',
    height: 'calc(100vh - 210px)',
    minHeight: 'calc(100vh - 210px)',
    transitionDuration: '700ms',
    scrollbarWidth: 'none',
    '&::scrollbar-track': {
      width: '0',
      minWidth: '0',
    },
    '&::-moz-scrollbar-track': {
      width: '0',
      minWidth: '0',
    },
    '&::-webkit-scrollbar-track': {
      width: '0',
      minWidth: '0',
    },
    '&::-webkit-scrollbar': {
      width: '0',
      minWidth: '0',
    },
    '&::-webkit-scrollbar-thumb': {
      width: '0',
      minWidth: '0',
    },
  },
  tabsContent: {
    marginBottom: '30px',
    overflowY: 'auto',
    height: 'calc(100vh - 210px)',
    minHeight: 'calc(100vh - 210px)',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar-track': {
      width: '0',
      minWidth: '0',
    },
    '&::-webkit-scrollbar': {
      width: '0',
      minWidth: '0',
    },
    '&::-webkit-scrollbar-thumb': {
      width: '0',
      minWidth: '0',
    },
  },
  tabs: {
    background: 'inherit',
    border: 'none',
  },
  tab: {
    minWidth: '85px',
    background: 'inherit',
    opacity: 0.7,
    height: '65px',
    padding: '0',
    paddingBottom: '10px',
    transitionDuration: '700ms',
    '&.Mui-selected': {
      background: '#303D8F',
      opacity: 1,
      transitionDuration: '700ms',

    },
    '&:hover': {
      transitionDuration: '700ms',
      background: '#303D8F',

    },
    '& .MuiTab-wrapper': {
      display: 'block',
    },
  },
  tabSingle: {
    minWidth: '80px',
    background: 'inherit',
    height: '65px',
    opacity: '1!important',
    padding: '0',
    paddingBottom: '10px',
    transitionDuration: '700ms',
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    alignItems: 'center',
    '&:hover': {
      transitionDuration: '700ms',
      background: '#303D8F',

    },

  },
  singleLink: {
    display: 'flex',
    minWidth: '85px',
    background: 'inherit',
    height: '80px',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    '&.active': {
      background: '#303D8F',
    },
  },
  icons: {
    width: '30px',
    margin: 'auto',
  },

  tabText: {
    color: '#fff',
    fontSize: '11px',
    lineHeight: '3px !important',

  },
}));
